import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { useEffect } from 'react';
import { useAddBusinessMemberMutation } from '../../../api/members';
import { useIdempotencyKey } from '../../../hooks/useIdempotencyKey';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { Route } from '../../../routes/account.business_.add-member';
import { MemberForm } from './MemberForm';

export function AddMemberPage() {
  const { t } = useTranslation();
  const navigate = Route.useNavigate();
  const idempotencyKey = useIdempotencyKey();
  const addMemberMutation = useAddBusinessMemberMutation({ idempotencyKey });

  useEffect(() => {
    if (addMemberMutation.isSuccess) {
      navigate({ to: '/account/business', replace: true });
    }
  }, [addMemberMutation.isSuccess, navigate]);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Invite member')}
          parent={{
            to: '/account/members',
            title: t('Linked members'),
          }}
        />
      }
      compact
    >
      <MemberForm mutation={addMemberMutation} />
    </MainLayout>
  );
}
